import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getPatientImmunizations = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/patient-immunizations`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const createPatientImmunization = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/patient-immunizations`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const schedulePatientImmunizations = (payload: {
  patientId: number;
  visitId?: number | null;
  vaccineIds?: number[];
  vaccineScheduleIds?: number[];
  scheduledDate: string;
  remarks?: string | null;
}) => {
  return new Promise((resolve, reject) => {
    api
      .post(
        `${BASE_URL}/api/v1/patient-immunizations/schedule`,
        camelToSnake(payload)
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updatePatientImmunization = (
  id: number | string,
  payload: any
) => {
  return new Promise((resolve, reject) => {
    api
      .put(
        `${BASE_URL}/api/v1/patient-immunizations/${id}`,
        camelToSnake(payload)
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const deletePatientImmunization = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .delete(`${BASE_URL}/api/v1/patient-immunizations/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
